export default __webpack_public_path__ + "fd947498bc16392e76c23adf58513fb3.woff";